"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getTermsHref = function getTermsHref(offerIdentifier) {
  var isPartnerOffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isPartnerOffer) return "/offer/partner/".concat(offerIdentifier, "#terms");
  return "/offer/".concat(offerIdentifier, "#terms");
};
var _default = exports["default"] = getTermsHref;
module.exports = exports.default;